// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
.sidebar-item {
  display: block;
  background-color: var(--color-white, #fff);
  &:has(.item-container.separated) {
    margin-top: calc(var(--spacing, 0.25rem) * 2);
  }
  .item-container {
    display: flex;
    height: 100%;
    align-items: center;
    padding-block: calc(var(--spacing, 0.25rem) * 3);
    padding-right: calc(var(--spacing, 0.25rem) * 3) !important;
    padding-left: calc(var(--spacing, 0.25rem) * 2) !important;
    &.active {
      background-color: var(--color-gray-200, oklch(92.8% 0.006 264.531));
    }
    &:not(.active) {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-gray-200, oklch(92.8% 0.006 264.531));
        }
      }
    }
    &.separated {
      border-top-style: var(--tw-border-style);
      border-top-width: 1px;
      border-top-color: var(--color-gray-300, oklch(87.2% 0.01 258.338));
    }
    &.has-children {
      cursor: pointer;
      background-color: var(--color-gray-50, oklch(98.5% 0.002 247.839));
      --tw-font-weight: var(--font-weight-bold, 700);
      font-weight: var(--font-weight-bold, 700);
    }
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/container/sidebar/sidebar-menu/sidebar-item/sidebar-item.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACqBmB,iBAAQ;AAnB3B;EACW,cAAK;EAAC,0CAAQ;EAErB;IACW,6CAAI;EACd;EAED;IACmC,aAAI;IAA5B,YAAM;IAAuB,mBAAY;IAAtB,gDAAI;IAAV,2DAAK;IAAX,0DAAK;IAEnB;MACW,mEAAW;IACrB;IAED;MACW;QAAA;UAAA,mEAAiB;QAAA;MAAA;IAC3B;IAED;MACW,wCAAQ;MAAR,qBAAQ;MAAC,kEAAiB;IACpC;IAED;MACW,eAAc;MAAW,kEAAU;MAApB,8CAAS;MAAT,yCAAS;IAClC;EACJ;AACJ;AAPkB;EAAA,WAAQ;EAAR,eAAQ;EAAR,oBAAQ;AAAA;AAIO;EAAA,WAAS;EAAT,eAAS;AAAA;AAJxB;EAAA;IAAA;MAAA,wBAAQ;MAIO,yBAAS;IAJhB;EAAA;AAAA","sourcesContent":[null,"@reference '../../../../../../assets/css/main.css';\r\n\r\n.sidebar-item {\r\n    @apply block bg-white;\r\n\r\n    &:has(.item-container.separated) {\r\n        @apply mt-2;\r\n    }\r\n    \r\n    .item-container {\r\n        @apply h-full pl-2! pr-3! py-3 flex items-center;\r\n\r\n        &.active {\r\n            @apply bg-gray-200;\r\n        }\r\n\r\n        &:not(.active) {\r\n            @apply hover:bg-gray-200;\r\n        }\r\n\r\n        &.separated {\r\n            @apply border-t border-t-gray-300;\r\n        }\r\n\r\n        &.has-children {\r\n            @apply cursor-pointer font-bold bg-gray-50;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
